import { useFormik } from "formik";
import { Button } from "primereact/button";
import * as Yup from "yup";
import { useTranslation } from "@i18n/hooks";
import {
	type EditUserInAccountGroupFormProps,
	type EditUserInAccountGroupFormState,
} from "./edit-user-in-account-group-form.interface";
import { ValidatedField } from "../../../components/ValidatedField";
import { SelectAccountGroups } from "../select-account-groups";

export const EditUserInAccountGroupForm = ({
	groupsId,
	onSubmitted,
	accountId,
}: EditUserInAccountGroupFormProps) => {
	const { t } = useTranslation("common");
	const formik = useFormik<EditUserInAccountGroupFormState>({
		initialValues: { groupsId },
		enableReinitialize: true,
		validationSchema: Yup.object().shape({
			groupsId: Yup.array().of(Yup.string()),
		}),
		onSubmit: (data, { setSubmitting }) => {
			onSubmitted(data, () => {
				setSubmitting(false);
			});
		},
	});

	return (
		<form onSubmit={formik.handleSubmit} className="w-12 p-fluid mb-5">
			<ValidatedField<EditUserInAccountGroupFormState, string[]>
				className="mb-4"
				name={"groupsId"}
				label={t("account.editGroups")}
				formikConfig={formik}
				placeholder={t("account.selectGroup")}
				component={(config) => <SelectAccountGroups {...config} accountId={accountId} />}
			/>
			<Button type="submit" label={t("account.saveGroups")} />
		</form>
	);
};
